import React, { useState } from 'react';
import { ButtonShowOrHideStyle } from './style';

export default function ButtonShowOrHidePassword({ typePassword, setTypePassword }) {
  const [iconPassword, setIconPassword] = useState('/images/icons/hide.svg');

  const showOrHidePassword = () => {
    if (typePassword === 'password') {
      setTypePassword('text');
      setIconPassword('/images/icons/show.svg');
    } else if (typePassword === 'text') {
      setTypePassword('password');
      setIconPassword('/images/icons/hide.svg');
    }
  };

  return (
    <ButtonShowOrHideStyle onClick={showOrHidePassword}>
      <img src={iconPassword} alt="mostrar senha" />
      <label>{typePassword === 'password' ? 'Mostrar senha' : 'Esconder senha'}</label>
    </ButtonShowOrHideStyle>
  );
}
